import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { clearContactNameCache } from '../../../services/userService'
import { UserContext } from '../UserContext'

export default function ClearContactNameCacheDialog({ ...opener }) {
  const { t } = useTranslation()
  const { currentUser, fetchCurrentUser } = useContext(UserContext)
  const { error } = useNotifications()

  const confirmBtnOnClick = async () => {
    try {
      opener.close()
      await clearContactNameCache(currentUser.dmcUser.cisId)
      fetchCurrentUser()
    } catch (err) {
      error(
        t('user.errors.clearingContactName', {
          defaultValue: `Error clearing contact name cache: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay
      {...opener}
      title={t('user.buttons.clearContactNameCache.description', 'Clear Contact Name Cache')}
      subtitle={currentUser.dmcUser.cisId.split('.')[2]}
    >
      <Paragraph size="sm">
        {t(
          'user.buttons.clearContactNameCache.dialog.body',
          "Are you sure you want to clear this user's contact name cache?"
        )}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={opener.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
